import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLsLabeling = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 4,
			height: 4,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 17,
			width: 4,
			height: 4,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 3,
			width: 4,
			height: 4,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 17,
			width: 4,
			height: 4,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 8,
			width: 2,
			height: 8,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 20,
			width: 2,
			height: 8,
			transform: "rotate(-90 8 20)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18,
			y: 8,
			width: 2,
			height: 8,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 6,
			width: 2,
			height: 8,
			transform: "rotate(-90 8 6)",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgLsLabeling);
export { ForwardRef as ReactComponent };
